import { recoilPersist } from "recoil-persist";

import { atom } from "recoil";
import { encryptString } from "util/encryptUtil";

type UserInfo = {
  role: string;
  name: string;
  latestDt: string;
  isAuthenticated: boolean;
}

export const userInfoPersist = recoilPersist({
  key: 'userInfo',
  storage: sessionStorage,
  converter: JSON
})

export const userInfoState = atom<UserInfo>({
  key: 'userInfoState',
  default: {
    role: encryptString('1'),
    name: '',
    latestDt: '',
    isAuthenticated: false,
  },
  effects_UNSTABLE: [userInfoPersist.persistAtom]
})